import React from 'react'
import Nigeria from '../../assets/svg/country-flags/ng.svg'
import Ghana from '../../assets/svg/country-flags/gh.svg'
import Rwanda from '../../assets/svg/country-flags/rw.svg'
import Kenya from '../../assets/svg/country-flags/ke.svg'
import Morocco from '../../assets/svg/country-flags/ma.svg'

export const CountryFlag = ({ country, className }) => {
  const countryCodeMap = {
    nigeria: 'ng',
    ghana: 'gh',
    rwanda: 'rw',
    kenya: 'ke',
    morocco: 'ma',
    'south africa': 'za',
    'united states': 'us',
    'united stated': 'us',
    'united kingdom': 'gb',
    canada: 'ca',
    egypt: 'eg',
    ethiopia: 'et',
    tanzania: 'tz',
    'ivory coast': 'ci',
    'democratic republic of the congo': 'cd',
    'sierra leone': 'sl',
    senegal: 'sn',
    algeria: 'dz',
    tunisia: 'tn',
    'burkina faso': 'bf',
    'south sudan': 'ss',
    'central african republic': 'cf',
    gabon: 'ga',
    'equatorial guinea': 'gq',
    'guinea-bissau': 'gw',
    botswana: 'bw',
    namibia: 'na',
    'cape verde': 'cv',
    madagascar: 'mg',
    angola: 'ao',
    zambia: 'zm',
    mozambique: 'mz',
    sudan: 'sd',
    mali: 'ml',
    chad: 'td',
    cameroon: 'cm',
    uganda: 'ug',
    niger: 'ne',
    benin: 'bj',
    togo: 'tg',
    somalia: 'so',
    zimbabwe: 'zw',
    libya: 'ly',
    mauritius: 'mu',
    seychelles: 'sc',
    'saudi arabia': 'sa',
    'united arab emirates': 'ae',
    qatar: 'qa',
  }
  const formattedCountry = country?.toLowerCase().trim()
  const countryCode = countryCodeMap[formattedCountry]

  if (!countryCode) {
    return null
  }
  return (
    <img
      // src={
      //   country === 'nigeria'
      //     ? Nigeria
      //     : country === 'ghana'
      //     ? Ghana
      //     : country === 'rwanda'
      //     ? Rwanda
      //     : country === 'morocco'
      //     ? Morocco
      //     : country === 'kenya'
      //     ? Kenya
      //     : null
      // }
      src={`https://flagcdn.com/w40/${countryCode}.png`}
      alt={`country flag`}
      className={`object-fit min-w-[20px] min-h-[20px] max-w-[20px] rounded text-[5px] absolute -right-2 -bottom-2 ${className}`}
    />
  )
}

// https://flagcdn.com/w40/ng.png
